module.exports = __webpack_public_path__ + "static/media/home-article-one.54cd9ea5.jpg";